<div class="row">
  <div class='col-sm-12 col-md-4'>Type</div>
  <div class='col-sm-12 col-md-8'>
    <select class="browser-default form-control" [(ngModel)]="condition.displayType">
      <option value="show">Show</option>
      <option value="hide">Hide</option>
    </select>
  </div>
</div>
<div class="row">
  <div class='col-sm-12 col-md-4'>Question Set</div>
  <div class='col-sm-12 col-md-8'>
    <select class="browser-default form-control w-100" [(ngModel)]="condition.questionSet">
      <option *ngFor="let question_set of assessment.question_sets" [ngValue]="question_set">{{question_set.title}}</option>
    </select>
  </div>
</div>
<div class="row">
  <div class="col-sm-12 col-md-4">Question</div>
  <div class='col-sm-12 col-md-8'>
    <select class="browser-default form-control w-100" *ngIf="condition.questionSet" [(ngModel)]="condition.question">
      <option *ngFor="let question of condition.questionSet.questions" [ngValue]="question">{{question.prompt}}</option>
    </select>
  </div>
</div>
<div class="row" *ngIf="hasQuestion()">
  <div class="col-sm-12 col-md-4">Answer</div>
  <div class='col-sm-12 col-md-8'>
    <select class="browser-default form-control w-100" *ngIf="hasLabels()" [(ngModel)]="condition.answer">
      <option *ngFor="let label of getLabels()" [ngValue]="label">{{label.label}}</option>
    </select>
    <p class="alert alert-danger" *ngIf="!hasLabels()">This question has no answers to key off of.</p>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/condition-edit/condition-edit.component.html